<template>
  <div class="card mb-2">
    <b-card-header class="esep-blue-bg text-light">
      <h6  class="float-left font-weight-bold">{{ $t('parametrics.addNewCriteria')}}</h6>
    </b-card-header>
    <b-card-body>
      <b-row >
        <b-form-group
          id="input-criteria-add"
          :label="$t('parametrics.criteriaTitle')"
          label-for="criteria-title-add"
          label-align="left"
          class="col-8"
        >
          <b-input v-model="criteriaToAdd.title">

          </b-input>
        </b-form-group>
        <b-form-group
          v-if="evaluationCategories"
          id="input-eval-category"
          :label="$t('parametrics.evalCategory')"
          label-for="eval-category"
          label-align="left"
          class="col-4"
        >
          <b-form-select
            id="eval-category"
            text-field="title"
            value-field="id"
            v-model="criteriaToAdd.category.id" 
            :options="evaluationCategories"
          >
            <template #first>
              <b-form-select-option value="null" disabled> Επιλέξτε Κατηγορία</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-row>
      <b-row>
        <b-form-group
          id="input-eval-content-type"
          :label="$t('parametrics.evalContentType')"
          label-for="eval-content-type"
          label-align="left"
          class="col-4"
        >
          <b-form-select
            id="eval-content-type"
            v-model="criteriaToAdd.criteriaContentType" 
            :options="evalContentTypes"
          >
          </b-form-select>
        </b-form-group>
        <b-form-group
          id="input-criteria-low-description"
          :label="$t('parametrics.criteriaLowDescription')"
          label-for="criteria-low-description"
          label-align="left"
          class="col-4"
        >
          <b-input 
            :disabled="criteriaToAdd.criteriaContentType == 'TEXT'" 
            v-model="criteriaToAdd.criteriaLowDescription">

          </b-input>
        </b-form-group>
        <b-form-group
          id="input-criteria-high-description"
          :label="$t('parametrics.criteriaHighDescription')"
          label-for="criteria-high-description"
          label-align="left"
          class="col-4"
        >
          <b-input 
            :disabled="criteriaToAdd.criteriaContentType == 'TEXT'"
            v-model="criteriaToAdd.criteriaHighDescription">

          </b-input>
        </b-form-group>
      </b-row>
      <b-row>
        <b-form-group
          id="input-eval-type"
          :label="$t('parametrics.evalType')"
          label-for="eval-type"
          label-align="left"
          class="col-3"
        >
          <b-form-select
            id="eval-type"
            v-model="evalType" 
            :options="evaluationTypes">
          </b-form-select>
        </b-form-group>
        <b-form-group
          v-if="evalType == 'MODULE'"
          id="input-module"
          :label="$t('parametrics.module')"
          label-for="module"
          label-align="left"
          class="col-9"
        >
          <v-select
            id="module"
            :options="allModules"
            placeholder="Όλες"
            :clearable='true'
            label="title"
            v-model="criteriaToAdd.module"
            class="bg-white rounded"
            @input="getCriterias()"
          >
            <template #no-options="{ }">
              {{ $t("parametrics.noRequiredModulesToAdd") }}
            </template>
          </v-select>
        </b-form-group>
      </b-row>
      <b-row>
        <b-form-group
          id="input-criteria-description"
          :label="$t('parametrics.criteriaDescription')"
          label-for="criteria-description"
          label-align="left"
          class="col-12"
        >
          <b-input v-model="criteriaToAdd.description">
          </b-input>
        </b-form-group>
      </b-row>
      <b-row>
        <b-button class="esep-blue-bg float-left my-auto ml-3" variant="success" @click="addCriteria" :disabled="!criteriaToAdd.title || !criteriaToAdd.category.id">
          {{ $t("common.add") }}
        </b-button>
        <b-button class="float-left my-auto ml-3" variant="danger" @click="hideAddCriteria">
          {{ $t("common.cancel") }}
        </b-button>
      </b-row>
    </b-card-body>
  </div>
</template>

<script>
import trainingService from '../../services/training.service';
import {handleApiError} from "../../services/error.service";

export default {
  props: {
    allModules: Array
  },
  mounted() {
    this.getCriteriasCategories();
  },
  data() {
    return {
      criteriaToAdd: {
        title: null,
        category: { id: null },
        criteriaContentType: 'GRADE',
        criteriaLowDescription: null,
        criteriaHighDescription: null,
        criteriaStatus: 'ACTIVE',
        description: null,
        module: null
      },
      evaluationCategories: null,
      evalContentTypes: [
        { value: 'GRADE', text: this.$t('criteriaTypeEnums.GRADE') },
        { value: 'TEXT', text: this.$t('criteriaTypeEnums.TEXT') },
        { value: 'GRADE_AND_TEXT', text: this.$t('criteriaTypeEnums.GRADE_AND_TEXT') }
      ],
      evalType: 'MODULE',
      evaluationTypes: [
        { value: 'MODULE', text: this.$t('evaluationTypeEnums.MODULE') },
        { value: 'SESSION', text: this.$t('evaluationTypeEnums.SESSION') },
        { value: 'TRAINER', text: this.$t('evaluationTypeEnums.TRAINER') }
      ],
    }
  },
  methods: {
    getCriteriasCategories() {
      trainingService.getCriteriasCategories().then(
        (response) => {
          this.$log.debug('categories')
          this.$log.debug(response.data);
          this.evaluationCategories = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    addCriteria() {
      this.$log.debug(this.criteriaToAdd);
      trainingService.addCriteria(this.evalType != 'TRAINER' ? this.evalType.toLowerCase() : 'leader', this.criteriaToAdd).then(
        (response) => {
          this.$log.debug(response.data);
          this.$emit('refresh-list', this.$t('parametrics.criteriaAdded'));
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    hideAddCriteria() {
      this.$emit('hide-add-criteria');
    }
  }
}
</script>

<style>

</style>